import React from "react";
import { DotsLoader } from "@/components/common/Loader/DotsLoader";

import styles from "./UserLoadingMessage.module.css";

type Props = {};

export const UserLoadingMessage: React.FC<Props> = ({}) => {
  return (
    <div className={styles.container}>
      <div className={styles.bubble}>
        <DotsLoader className={styles.loader} />
      </div>
    </div>
  );
};
